import { IconProps } from './IconProps';

export const CircleTick = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2876_726)">
        <path
          d="M12.7148 25.4395C19.7363 25.4395 25.4395 19.7461 25.4395 12.7246C25.4395 5.70312 19.7363 0 12.7148 0C5.69336 0 0 5.70312 0 12.7246C0 19.7461 5.69336 25.4395 12.7148 25.4395ZM12.7148 23.623C6.68945 23.623 1.81641 18.75 1.81641 12.7246C1.81641 6.69922 6.68945 1.82617 12.7148 1.82617C18.7402 1.82617 23.6133 6.69922 23.6133 12.7246C23.6133 18.75 18.7402 23.623 12.7148 23.623Z"
          fill={props.fill ?? '#000000'}
        />
        <path
          d="M11.3379 18.7012C11.6992 18.7012 11.9922 18.5352 12.207 18.2031L18.1934 8.81836C18.3203 8.62305 18.4473 8.37891 18.4473 8.14453C18.4473 7.66602 18.0176 7.34375 17.5781 7.34375C17.2949 7.34375 17.0215 7.51953 16.8262 7.83203L11.2988 16.6113L8.54492 13.1641C8.29102 12.832 8.04688 12.7344 7.75391 12.7344C7.28516 12.7344 6.91406 13.1152 6.91406 13.5938C6.91406 13.8281 7.01172 14.0625 7.16797 14.2676L10.4297 18.2031C10.7031 18.5547 10.9766 18.7012 11.3379 18.7012Z"
          fill={props.fill ?? '#000000'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2876_726">
          <rect
            width="25.8008"
            height="25.459"
            fill={props.fill ?? '#000000'}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

